import Pusher from "pusher-js";

const DEFAULT_KEY = "dvmwxqcfjfddtolftxva";
const DEFAULT_HOST = "127.0.0.1";
/** Copy-trade Reverb. CRM chat stays on 6001. */
const DEFAULT_PORT = 6002;

const CHANNEL = "copy-trade.quotes";
const EVENT = "copy.trade.quotes";

/**
 * Subscribe to live Copy Trade quotes (one MT5 fetch on server → fan-out).
 * Uses the copy-trade Reverb host, separate from support chat.
 *
 * @param {(quotes: unknown[]) => void} onQuotes
 * @param {{ onConnected?: () => void, onDisconnected?: () => void }} [hooks]
 * @returns {() => void} unsubscribe / disconnect
 */
export function attachCopyTradeQuotesPusher(onQuotes, hooks = {}) {
  if (typeof onQuotes !== "function") return () => {};

  const key = process.env.REACT_APP_COPY_TRADE_PUSHER_KEY || process.env.REACT_APP_PUSHER_KEY || DEFAULT_KEY;
  const host = process.env.REACT_APP_COPY_TRADE_PUSHER_HOST || DEFAULT_HOST;
  const port = Number(process.env.REACT_APP_COPY_TRADE_PUSHER_PORT || DEFAULT_PORT, 10) || DEFAULT_PORT;
  const forceTlsSetting = process.env.REACT_APP_COPY_TRADE_PUSHER_FORCE_TLS;
  const forceTLS = forceTlsSetting == null
    ? window.location.protocol === "https:"
    : forceTlsSetting !== "false";

  const pusher = new Pusher(key, {
    cluster: "mt1",
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS,
    enabledTransports: ["ws", "wss"],
    disableStats: true,
  });

  const channel = pusher.subscribe(CHANNEL);

  const handler = (payload) => {
    try {
      const data = typeof payload === "string" ? JSON.parse(payload) : payload;
      const rows = data?.DATA ?? data?.data ?? [];
      if (Array.isArray(rows)) onQuotes(rows);
    } catch (_) {
      /* ignore bad payloads */
    }
  };

  channel.bind(EVENT, handler);
  // Laravel prefixes custom event names with "." when using broadcastAs().
  channel.bind(`.${EVENT}`, handler);

  pusher.connection.bind("connected", () => {
    if (typeof hooks.onConnected === "function") hooks.onConnected();
  });
  pusher.connection.bind("disconnected", () => {
    if (typeof hooks.onDisconnected === "function") hooks.onDisconnected();
  });
  pusher.connection.bind("unavailable", () => {
    if (typeof hooks.onDisconnected === "function") hooks.onDisconnected();
  });
  pusher.connection.bind("failed", () => {
    if (typeof hooks.onDisconnected === "function") hooks.onDisconnected();
  });

  return () => {
    try {
      channel.unbind(EVENT, handler);
      channel.unbind(`.${EVENT}`, handler);
      pusher.unsubscribe(CHANNEL);
      pusher.disconnect();
    } catch (_) {
      /* ignore */
    }
  };
}
